export function getSolveColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1.2,
            editable: false,
        },
        {
            field: "puzzleTitle",
            headerName: "Puzzle",
            flex: 1.2,
            editable: false,
            alignItems: "center",
        },
        {
            field: "startedAt",
            headerName: "Started",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "finishedAt",
            headerName: "Finished",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.9,
            editable: false,
            alignItems: "center",
        },
        {
            field: "attemptsCount",
            headerName: "Attempts",
            flex: 0.8,
            editable: false,
            alignItems: "center",
            type: "number",
        },
    ];
}
